export const diplomeData = [
  {
    slug: "bts-cg",
    titre: "BTS CG",
    intituleLongFormation: "COMPTABILITE ET GESTION",
    romes: ["M1203"],
  },
  {
    slug: "bts-communication",
    titre: "BTS Communication",
    intituleLongFormation: "COMMUNICATION",
    romes: ["E1103"],
  },
  {
    slug: "bts-gpme",
    titre: "BTS GPME",
    intituleLongFormation: "GESTION DE LA PME",
    romes: ["M1203", "M1501", "M1604"],
  },
  {
    slug: "bts-mco",
    titre: "BTS MCO",
    intituleLongFormation: "MANAGEMENT COMMERCIAL OPERATIONNEL",
    romes: ["D1401", "D1501", "D1506", "M1704", "M1705"],
  },
  {
    slug: "bts-ndrc",
    titre: "BTS NDRC",
    intituleLongFormation: "NEGOCIATION ET DIGITALISATION DE LA RELATION CLIENT",
    romes: ["D1401", "D1406", "D1501", "M1703", "M1704"],
  },
  {
    slug: "bts-sam",
    titre: "BTS SAM",
    intituleLongFormation: "SUPPORT A L'ACTION MANAGERIALE",
    romes: ["M1604"],
  },
  {
    slug: "bts-sio",
    titre: "BTS SIO",
    intituleLongFormation: "SERVICES INFORMATIQUES AUX ORGANISATIONS",
    romes: ["M1801", "M1805", "M1810"],
  },
  {
    slug: "cap-aepe",
    titre: "CAP AEPE",
    intituleLongFormation: "ACCOMPAGNANT EDUCATIF PETITE ENFANCE",
    romes: ["K1303"],
  },
  {
    slug: "licence-pro-rh",
    titre: "Licence Pro RH",
    intituleLongFormation: "RESSOURCES HUMAINES",
    romes: ["K1801", "K2101", "K2111", "M1203", "M1402", "M1403", "M1501", "M1502", "M1503", "M1604", "M1806"],
  },
  {
    slug: "titre-pro-secretaire-medicale",
    titre: "Titre Pro Secrétaire Médicale",
    intituleLongFormation: "SECRETAIRE MEDICAL",
    romes: ["M1609"],
  },
  {
    slug: "cap-esthetique",
    titre: "CAP Esthétique",
    intituleLongFormation: "ESTHETIQUE COSMETIQUE PARFUMERIE",
    romes: ["D1208"],
  },
  {
    slug: "cap-coiffure",
    titre: "CAP Coiffure",
    intituleLongFormation: "METIERS DE LA COIFFURE",
    romes: ["D1202"],
  },
  {
    slug: "cap-cuisine",
    titre: "CAP Cuisine",
    intituleLongFormation: "CUISINE",
    romes: ["G1602"],
  },
  {
    slug: "cap-patissier",
    titre: "CAP Pâtissier",
    intituleLongFormation: "PATISSIER",
    romes: ["D1104"],
  },
  {
    slug: "cap-electricien",
    titre: "CAP Électricien",
    intituleLongFormation: "ELECTRICIEN",
    romes: ["F1602", "F1605"],
  },
  {
    slug: "bac-pro-melec",
    titre: "Bac pro MELEC",
    intituleLongFormation: "METIERS DE L'ELECTRICITE ET DE SES ENVIRONNEMENTS CONNECTES",
    romes: ["F1602", "I1309"],
  },
  {
    slug: "bac-pro-ciel",
    titre: "Bac pro CIEL",
    intituleLongFormation: "CYBERSECURITE, INFORMATIQUE ET RESEAUX, ELECTRONIQUE",
    romes: ["I1401", "I1305", "I1307", "H2605"],
  },
  {
    slug: "bac-pro-mcv",
    titre: "Bac pro MCV",
    intituleLongFormation: "METIERS DU COMMERCE ET DE LA VENTE",
    romes: ["D1403", "D1507", "D1214", "D1212", "D1106", "D1408"],
  },
  {
    slug: "bac-pro-assp",
    titre: "Bac pro ASSP",
    intituleLongFormation: "ACCOMPAGNEMENT, SOINS ET SERVICES A LA PERSONNE",
    romes: ["K1302", "J1301"],
  },
  {
    slug: "titre-pro-advf",
    titre: "Titre Pro ADVF",
    intituleLongFormation: "ASSISTANT DE VIE AUX FAMILLES",
    romes: ["K1302", "K1304", "K1303"],
  },
  {
    slug: "cap-boucher",
    titre: "CAP Boucher",
    intituleLongFormation: "BOUCHER",
    romes: ["D1101"],
  },
  {
    slug: "cap-monteur-installations-sanitaires",
    titre: "CAP MIS (plombier)",
    intituleLongFormation: "MONTEUR EN INSTALLATIONS SANITAIRES",
    romes: ["F1603"],
  },
  {
    slug: "capa-jardinier-paysagiste",
    titre: "CAP agricole Jardinier Paysagiste",
    intituleLongFormation: "JARDINIER PAYSAGISTE",
    romes: ["A1208", "A1203", "A1202"],
  },
  {
    slug: "cap-psr",
    titre: "CAP PSR",
    intituleLongFormation: "PRODUCTION ET SERVICE EN RESTAURATIONS",
    romes: ["G1603", "G1607", "G1803"],
  },
  {
    slug: "cap-boulanger",
    titre: "CAP Boulanger",
    intituleLongFormation: "BOULANGER",
    romes: ["D1102"],
  },
  {
    slug: "bac-pro-agora",
    titre: "Bac pro AGOrA",
    intituleLongFormation: "ASSISTANCE A LA GESTION DES ORGANISATIONS ET DE LEURS ACTIVITES",
    romes: ["M1602", "M1607", "D1401", "M1501"],
  },
  {
    slug: "cap-fleuriste",
    titre: "CAP Fleuriste",
    intituleLongFormation: "FLEURISTE",
    romes: ["D1209"],
  },
  {
    slug: "bac-pro-tci",
    titre: "Bac pro TCI (chaudronnerie)",
    intituleLongFormation: "TECHNICIEN EN CHAUDRONNERIE INDUSTRIELLE",
    romes: ["H2902", "H2913", "H2914"],
  },
  {
    slug: "cap-epc",
    titre: "CAP Équipier polyvalent du commerce",
    intituleLongFormation: "EQUIPIER POLYVALENT DU COMMERCE",
    romes: ["D1507", "D1505", "D1106", "D1214", "D1107"],
  },
  {
    slug: "bac-pro-mspc",
    titre: "Bac pro MSPC",
    intituleLongFormation: "MAINTENANCE DES SYSTEMES DE PRODUCTION CONNECTES",
    romes: ["I1304", "I1310"],
  },
]
